import { Flex, FlexProps } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import { CashbackMessage } from "components/Cashback/CashbackMessage";
import { EvalIds, RegionType } from "graphql/generated";
import { CURRENT_COUNTRY } from "src/constants/Countries";
import { CheckoutTypes } from "src/types/checkout";

import { DueNowRow } from "./DueNowRow";
import PricesSection from "./PricesSection";
import PromotionSection from "./PromotionSection";

type Props = FlexProps &
  CheckoutTypes & {
    allowAction?: boolean;
    shouldShowCashback?: boolean;
  };

export const CheckoutSummaryInfo = ({
  summary,
  items,
  allowAction = true,
  shouldShowCashback = true,
  ...props
}: Props) => {
  const { t } = useTranslation(["prescription_checkout"]);
  const isCovidProd =
    CURRENT_COUNTRY === RegionType.Hk &&
    items.length === 1 &&
    items[0].product.evaluationId.noah === EvalIds.CovidTeleconsult;

  return (
    <Flex direction="column" {...props}>
      <PricesSection
        t={t}
        items={items}
        summary={summary}
        allowAction={allowAction}
        shouldShowCashback={shouldShowCashback}
      />
      <PromotionSection
        isCovidProd={isCovidProd}
        t={t}
        summary={summary}
        items={items}
        allowAction={allowAction}
      />

      <DueNowRow summary={summary} />

      <CashbackMessage cashbackAmount={summary.cashbackEarned} mt={2} />
    </Flex>
  );
};
